
export const authorizedRepresentativeTypes = {
    SELF: 'SELF',
    PROFESSIONAL_ASSISTANT: 'PROFESSIONAL_ASSISTANT',
    NON_PROFESSIONAL_ASSISTANT: 'NON_PROFESSIONAL_ASSISTANT',
    UNSPECIFIED: 'UNSPECIFIED'
};